import "./AsideContent.scss";

import React from "react";

import { AsideContentData } from "../../models/app-data-model";
import { getAsideNavLinks } from "../../services/get-aside-nav-links";
import AsideCallouts from "../aside-callouts/AsideCallouts";
import AsideNavigation from "../aside-navigation/AsideNavigation";

export type AsideContentProps = {
  asideContent?: AsideContentData;
};

const AsideContent: React.FC<AsideContentProps> = (props: AsideContentProps) => {
  const asideNavLinks = props.asideContent?.aside_navigations && getAsideNavLinks(props.asideContent?.aside_navigations);
  const asideNavigations = asideNavLinks && <AsideNavigation navLinks={asideNavLinks} />;
  const asideCallouts = props.asideContent?.aside_call_outs && <AsideCallouts asideCallouts={props.asideContent?.aside_call_outs} />
  return <>
    {asideCallouts}
    {asideNavigations}
  </>
};

export default AsideContent;
